import i18n from 'i18next';

/**
 * The Evals skeleton's own namespace (SL-1948). The skeleton is in the initial
 * bundle (RouteSkeleton, the agent layouts, the router), so it must not import
 * the `evals` namespace — the module's whole copy, which every user would
 * download before any screen. It carries only what the skeleton says: its label.
 * `__tests__/EvalsSkeleton.test.tsx` keeps the three languages in step.
 */
export const NS = 'evals-skeleton';

export const en = { loading: 'Loading the evaluation tests' };
export const es: typeof en = { loading: 'Cargando las pruebas de evaluación' };
export const pt: typeof en = { loading: 'Carregando os testes de avaliação' };

// Guarded so importing this module is safe where the i18next singleton isn't
// initialized (the jest runner); in the app it is, before the first render.
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}
